import 'moment/locale/id';
import React, { Component } from 'react';
import "react-toggle/style.css";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { isInteger, isFunction } from 'iotera-base/object';
import { TablePaginationActionsWrapped, CustomTableCell } from '..';
import { TAG_CAT_SINGLE_SELECTION, TAG_CAT_CHECKBOX, TAG_CAT_MULTI_VALUE, TAG_CAT_SINGLE_VALUE } from '../../../lib/components/Preference';
/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import { safeDeepGetWithType } from 'iotera-base/json';
import { getWidthColumnByPercent } from '../../../lib/components/function';

let colors = ['#7E57C2'];

export default class TagTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 10,
      dropdownOpen: {}
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event, id, cat) {
    let on_click = safeDeepGetWithType(this, ['props', 'on_click']);
    if (isFunction(on_click)) {
      on_click(id, cat);
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage))
      rowsPerPage = parseInt(rowsPerPage)
    this.setState({ page: 0, rowsPerPage });
  };

  onMouseEnter(key, cat) {
    let dropdownOpen = Object.assign({}, this.state.dropdownOpen);
    // set dropdown visible 
    dropdownOpen[key] = true;
    this.setState({ dropdownOpen });
  }

  onMouseLeave(key) {
    let dropdownOpen = Object.assign({}, this.state.dropdownOpen);
    // set dropdown hidden 
    dropdownOpen[key] = false;
    this.setState({ dropdownOpen });
  }

  handleAllCheck = event => {
    this.props.data.forEach((device, index, devices) => {
      devices[index].selected = event.target.checked
    })
    this.props.onCheckedDevice(event.target.checked)
  }

  handleCheck = (index, event) => {
    this.props.data[index].selected = event.target.checked
    this.props.onCheckedDevice(event.target.checked)
  }

  render() {
    let tableWidth = safeDeepGetWithType(this, ['props', 'tableSize', 'width'], 0);
    let data = this.props.data;
    const { rowsPerPage, page } = this.state;
    let taskRows = []
    let firstMore = true;
    let alreadyMore = false;
    Object.keys(data).forEach((key, index) => {
      let cardContent = data[key];
      let definitions = []
      let tagsMore = []
      let activeText = ""
      let j = 0;
      let k = 0;
      let sizeTags = 0;
      let sizeTagsMore = 0;
      let selection = safeDeepGetWithType(cardContent, 'definitions', []);
      if (selection.length === 0) {
        definitions.push(
          '-'
        )
      } else {
        let color = colors[Math.floor(Math.random() * colors.length)];
        for (let i = 0; i < selection.length; i++) {
          let tagName = selection[i].name;
          let nameLc = '{' + selection[i].name_lc + '}'
          let tagFullDef =
            <span key={key + k++} href='#' className='text-white'>{tagName}
              <span style={{ fontStyle: 'italic' }}> {nameLc}</span>
            </span>
          let hasTwoWords = tagName.includes(" ");
          let initialName = ""
          if (hasTwoWords) {
            let matches = tagName.match(/\b(\w)/g);
            let acronym = matches.join('');
            initialName = acronym.charAt(0) + acronym.slice(-1);
          } else {
            initialName = tagName.substring(0, 2);
          }
          let defWidth = getWidthColumnByPercent(45, tableWidth)
          if (defWidth > 100) {
            defWidth -= 36
          }
          if (sizeTags + 1 > defWidth / 36) {
            alreadyMore = true;
          }
          if ((sizeTags >= defWidth / 36) || (alreadyMore === true)) {
            // TODO +icon
            if (firstMore === true) {
              firstMore = false;
            } else {
              tagsMore.push(<span key={key + k++} className='text-white'>,&nbsp;</span>)
            }
            sizeTagsMore++;
            tagsMore.push(
              <span key={key + k++} href='#' className='text-white'>{tagFullDef}</span>
            )
          } else {
            sizeTags++;
            definitions.push(
              <span key={key + i + k++}>
                <Tooltip TransitionComponent={Zoom} title={tagFullDef} placement='bottom-start' enterDelay={500} >
                  <span className="numberCircle" style={{ backgroundColor: color, borderColor: color }} >{initialName.toUpperCase()}</span>
                </Tooltip>
              </span>
            )
          }
        }
        if (((sizeTags >= 6) && (sizeTagsMore !== 0)) || (alreadyMore === true)) {
          let textMore = sizeTagsMore > 9 ? '+' : sizeTagsMore;
          definitions.push(
            <span key={key + j++}>
              <Tooltip TransitionComponent={Zoom} title={tagsMore} placement='bottom-start' enterDelay={500} >
                <span className="numberCircle" style={{ backgroundColor: color, borderColor: color }} >{'+' + textMore}</span>
              </Tooltip>
            </span>
          )
        }
      }
      if (cardContent.category === TAG_CAT_SINGLE_SELECTION) {
        activeText = <span>Single Selection</span>
      } else if (cardContent.category === TAG_CAT_SINGLE_VALUE) {
        activeText = <span>Single Value</span>
      } else if (cardContent.category === TAG_CAT_CHECKBOX) {
        activeText = <span>Single Checkbox</span>
      } else if (cardContent.category === TAG_CAT_MULTI_VALUE) {
        activeText = <span>Multi Value</span>
      }
      // get dropdown is open or not
      let dropdownIsOpen = safeDeepGetWithType(this, ['state', 'dropdownOpen', index], false);
      taskRows.push(
        <TableRow key={index} className='table-row-child-iotera' >
          <TableCell component="th" scope="row" column='prefix' style={{ textAlign: 'left' }}>
            <span style={{ fontWeight: 'bold' }}>
              <span>{cardContent.prefix}</span><br />
            </span>
          </TableCell>
          <TableCell column='name' style={{ textAlign: 'left', minWidth: 164, maxWidth: 164 }}>
            <span style={{ fontStyle: 'italic' }}>
              {cardContent.name}
            </span>
          </TableCell>
          <TableCell column='tipe' >
            <span>
              {activeText}
            </span>
          </TableCell>
          <TableCell column='definitions' >
            <span>
              {definitions}
            </span>
          </TableCell>
          <TableCell column='settings' style={{ textAlign: 'center' }} onMouseLeave={(e) => this.onMouseLeave(index)} >
            <UncontrolledDropdown isOpen={dropdownIsOpen}>
              <DropdownToggle tag="div">
                <IconButton onMouseOver={(e) => this.onMouseEnter(index, cardContent.category)} style={{ cursor: 'pointer', padding: 4 }}>
                  <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
                </IconButton>
              </DropdownToggle>
              <DropdownMenu style={{ padding: 0, margin: 0 }}>
                <DropdownItem style={{ margin: 0 }} onClick={(e) => this.handleClick(e, cardContent.prefix, cardContent.category)}>
                  <AddIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span style={{ marginRight: 20 }}>Pilihan</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </TableCell>
        </TableRow>
      )
      firstMore = true;
      alreadyMore = false;
    }
    )
    return (
      <Table className="table">
        <TableHead style={{ height: 0 }}>
          <TableRow>
            <CustomTableCell column='prefix' style={{
              minWidth: getWidthColumnByPercent(15, tableWidth),
              maxWidth: getWidthColumnByPercent(15, tableWidth)
            }}><span>ID</span></CustomTableCell>
            <CustomTableCell column='name' style={{
              minWidth: getWidthColumnByPercent(15, tableWidth),
              maxWidth: getWidthColumnByPercent(15, tableWidth)
            }}><span>Nama</span></CustomTableCell>
            <CustomTableCell column='category' style={{
              minWidth: getWidthColumnByPercent(15, tableWidth),
              maxWidth: getWidthColumnByPercent(15, tableWidth)
            }}><span>Tipe</span></CustomTableCell>
            <CustomTableCell column='pilihan' style={{
              minWidth: getWidthColumnByPercent(45, tableWidth),
              maxWidth: getWidthColumnByPercent(45, tableWidth)
            }}><span>Pilihan</span></CustomTableCell>
            <CustomTableCell column='settings' style={{
              textAlign: 'center', minWidth: getWidthColumnByPercent(10, tableWidth),
              maxWidth: getWidthColumnByPercent(10, tableWidth)
            }}><span>Aksi</span></CustomTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {taskRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
              labelRowsPerPage='Baris terlihat:'
              rowsPerPageOptions={[5, 10, 25]}
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                native: true,
              }}
              onPageChange={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActionsWrapped}
            />
          </TableRow>
        </TableFooter>
      </Table>
    );
  }
}